import React from "react";

const Basics = () => {
  return (
    <div className="basics-page">
      <div className="basics-container">
        <h2>
          1-TYPESCRIPT AUTOMATICALLY ASSIGNS A TYPE WHEN YOU DEFINE A VARIABLE
        </h2>
        <p>
          Here I want to express that typeScript know type automatically even if
          you don't define it , for example here I define variable : "Hello
          developers" , the most important thing here that typescript detect the
          that the type should be a string and if you diffine it diffrenetly it
          will display an error of type.
        </p>
        <img src="/img/b1.png" alt="Type-asingning-auto" className="image" />
        <h2>2-EXPLICITLY PROVIDING A TYPE</h2>
        <p>
          In this example I want to indicate that in type script we can decalare
          the type and define the initial value from the begining , here I
          define the type: number and at the same time I define the intitial
          value also
        </p>
        <img src="/img/b2.png" alt="Explicity-define-type" className="image" />
        <h2>3-BASIC TYPES</h2>
        <p>
          TypeScript, as a superset of JavaScript, enhances the language by
          adding static types. These types allow developers to specify what kind
          of values can be assigned to variables, parameters, and object
          properties, helping to catch errors at compile time rather than at
          runtime. Here's a brief overview of the basic types in TypeScript:{" "}
          <br />
          <b> &#10003; boolean :</b> The most basic datatype is the simple
          true/false value, which JavaScript and TypeScript call a boolean
          value.
        </p>
        <img src="/img/b3.png" alt="BasicType" className="image" />
        <p>
          <b> &#10003; number :</b> In TypeScript, all numbers are floating
          point values. These floating-point numbers get the type number.
          TypeScript also supports hexadecimal, binary, and octal literals.
        </p>
        <img src="/img/b4.png" alt="BasicType" className="image" />
        <p>
          <b> &#10003; string :</b> Another fundamental part of creating
          programs in JavaScript for webpages and servers alike is working with
          textual data. As in other languages, we use the type string to refer
          to these textual datatypes.
        </p>
        <img src="/img/b5.png" alt="BasicType" className="image" />
        <p>
          <b>&#10003; arrays :</b> In TypeScript, like JavaScript, allows you to
          work with arrays of values. There are two syntaxes for declaring array
          types:
        </p>
        <ul className="array-option">
          <li>
            <b>Element Type[]:</b> You can declare an array by writing the type
            of its elements followed by <code>[]</code>. This denotes an array
            of that element type.
          </li>
          <li>
            <b>Generic Array Type:</b> Alternatively, you can use the generic
            array type, <code>Array&lt;ElementType&gt;</code>, where&nbsp;
            <code>ElementType</code> represents the type of the elements in the
            array.
          </li>
        </ul>
        <img src="/img/b6.png" alt="BasicType" className="image" />
        <p>
          <b> &#10003; tuple :</b> TypeScript allows you to express an array
          where the type of a fixed number of elements is known, but need not be
          the same.
        </p>
        <img src="/img/b7.png" alt="BasicType" className="image" />
        <p>
          <b> &#10003; enum :</b> A helpful addition to the standard set of
          datatypes from JavaScript is the enum. Like languages such as C#, an
          enum is a way of giving more friendly names to sets of numeric values.
        </p>
        <img src="/img/b8.png" alt="BasicType" className="image" />
        <p>
          <b> &#10003; any :</b> The any type is a powerful way to work with
          existing JavaScript, allowing you to gradually opt-in and opt-out of
          type-checking during compilation. The any type is used when the type
          of a variable is unknown.
        </p>
        <img src="/img/b9.png" alt="BasicType" className="image" />
        <p>
          <b> &#10003; void :</b> The void type, like in C or Java, is used to
          indicate the absence of a return value for functions.
        </p>
        <img src="/img/b10.png" alt="BasicType" className="image" />
        <p>
          <b> &#10003; null and undefined :</b> In TypeScript, both undefined
          and null actually have their own types named undefined and null
          respectively. Much like void, they’re not extremely useful on their
          own:
        </p>
        <img src="/img/b11.png" alt="BasicType" className="image" />
        <p>
          <b> &#10003; never :</b> The never type represents the type of values
          that never occur. For instance, never is the return type for a
          function expression or an arrow function expression that always throws
          an exception or one that never returns.
        </p>
        <img src="/img/b12.png" alt="BasicType" className="image" />
        <p>
          <b> &#10003; object :</b> object is a type that represents the
          non-primitive type, i.e., anything that is not number, string,
          boolean, symbol, null, or undefined.
        </p>
        <img src="/img/b13.png" alt="BasicType" className="image" />
        <p>
          By using these basic types, TypeScript developers can write more
          predictable code and benefit from the TypeScript compiler's type
          checking and error reporting functionalities.
        </p>
        <h2>4-MULTIPLE TYPES (UNION TYPES)</h2>
        <p>
          Union types in TypeScript allow a variable to be one of several types,
          enabling more flexible code by declaring that a value can be one of a
          set of distinct types.
          <br />
          In this example I declare my variable as a string <b>or</b> a number.
          <img src="/img/b14.png" alt="BasicType" className="image" />
        </p>
        <h2>5-ARRAYS</h2>
        <p>
          Arrays in TypeScript are collections of elements of the same type,
          defined with type annotations to enforce consistent content.
        </p>
        <img src="/img/b15.png" alt="BasicType" className="image spacial" />
        <h2>6-OBJECTS</h2>
        <p>
          Objects in TypeScript are structured data types that can be typed to
          specify the shape and type of their properties and methods.
        </p>
        <br />
        <p>
          In this example I declare a user type then after we can also redeclare
          the value of our object bur with the some type
        </p>
        <img src="/img/b16.png" alt="BasicType" className="image moy" />
        <p>
          In this example I want to show you how to declare options in
          typeScript , all we need is to add the question mark symbol
        </p>
        <img src="/img/b17.png" alt="BasicType" className="image moy" />
        <h2>7-ANY TYPES</h2>
        <p>
          The any type in TypeScript allows any value, providing a way to
          opt-out of type checking for variables.
        </p>
        <img src="/img/b18.png" alt="BasicType" className="image moy" />
        <p>
          Be carful here I want to show you that with any type we can add to the
          array any type string, number, or any other type
        </p>
        <img src="/img/b19.png" alt="BasicType" className="image" />
        <h2>8-FUNCTIONS</h2>
        <p>
          Functions in TypeScript are used to define blocks of code that perform
          specific tasks and can be typed with parameters and return values for
          enhanced code reliability.
        </p>
        <p>
          In this example fonction declared with a void as a return parameter
          which mean that this function doesn't return anything as a value , it
          can for ecample return a console log
        </p>
        <img src="/img/b20.png" alt="BasicType" className="image" />
        <p>In this example this fonction need to return a string value :</p>
        <img src="/img/b21.png" alt="BasicType" className="image" />
        <p>This is how we can declare a function with a return value :</p>
        <img src="/img/b22.png" alt="BasicType" className="image" />
        <h2>9-TYPE ALIASES</h2>
        <p>
          Type aliases in TypeScript allow you to create custom type
          definitions, providing a shorthand to refer to complex type structures
          or union types.
        </p>
        <img src="/img/b23.png" alt="BasicType" className="image moy" />
        <h2>10-FUNCTION SIGNATURES</h2>
        <p>
          Function signatures in TypeScript define the types of parameters and
          the return type of functions, ensuring type safety and predictability
          in function usage.
        </p>
        <img src="/img/b24.png" alt="BasicType" className="image" />

        <p>
          In this example I define a specific type and then I used in my
          function, we use functions signature to pre-define all the attribute
          in the fuction , and to ensure also the return value
        </p>
        <img src="/img/b25.png" alt="BasicType" className="image moy" />
        <h2>11-INTERFACES</h2>
        <p>
          Interfaces in TypeScript declare shapes for objects, enforcing a
          contract for the structure of an object or class. <br />
          In TypeScript, interfaces define contracts for object shapes and can
          be extended or implemented, whereas types can represent a wider range
          of constructs and are not extendable but can be intersected.
        </p>
        <p>
          Here in this example I want to show you that in the types we use the
          equal (=) sign but in the interfrace we dont need any sign (be
          careful)
        </p>
        <img src="/img/b26.png" alt="BasicType" className="image moy" />

        <p>
          Here for example I create a IEmployee that extends from Iuser some
          attributes , (here come the utility for the interfaces and the gain of
          time)
        </p>

        <img src="/img/b27.png" alt="BasicType" className="image moy" />

        <h2>12-GENERICS</h2>

        <p>Here's a basic example of a generic function in TypeScript:</p>
        <img src="/img/b28.png" alt="BasicType" className="image" />

        <p>
          This function identity takes a single argument arg of any type T and
          returns an argument of the same type T. You can use this generic
          function with any type:
        </p>
        <img src="/img/b29.png" alt="BasicType" className="image" />
      </div>
    </div>
  );
};

export default Basics;
